function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmSelfcareActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37.5pt",
    height: "37.5pt",
    viewBox: "0 0 37.5 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,88.235294%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 2.25 20.671875 C -4.835938 27.609375 15.097656 40.386719 19.957031 34.5 C 24.816406 28.613281 32.828125 32.308594 34.664062 28.058594 C 41.113281 13.140625 31.175781 17.042969 24.117188 13.058594 C 19.5 10.5 23.453125 -3.464844 9.898438 3.367188 C -3.652344 10.199219 9.367188 13.734375 2.25 20.671875 Z M 2.25 20.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,81.176471%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 10.769531 6.945312 L 26.738281 6.945312 C 28.148438 6.945312 29.289062 8.355469 29.289062 9.496094 L 29.289062 29.925781 C 29.289062 31.335938 28.148438 32.476562 26.738281 32.476562 L 10.769531 32.476562 C 9.359375 32.476562 8.21875 31.066406 8.21875 29.925781 L 8.21875 9.496094 C 8.21875 8.085938 9.359375 6.945312 10.769531 6.945312 Z M 10.769531 6.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 10.769531 6.945312 L 26.738281 6.945312 C 28.148438 6.945312 29.289062 8.355469 29.289062 9.496094 L 29.289062 29.289062 C 29.289062 30.699219 28.148438 31.839844 26.738281 31.839844 L 10.769531 31.839844 C 9.359375 31.839844 8.21875 30.429688 8.21875 29.289062 L 8.21875 9.496094 C 8.21875 8.085938 9.359375 6.945312 10.769531 6.945312 Z M 10.769531 6.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.40625 10.132812 L 26.082031 10.132812 L 26.082031 29.28125 L 11.40625 29.28125 Z M 11.40625 10.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 11.40625 29.28125 L 26.09375 29.28125 L 26.09375 19.949219 Z M 11.40625 29.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.730469 6.945312 C 28.136719 6.945312 29.28125 8.085938 29.28125 9.496094 L 29.28125 29.917969 C 29.28125 31.328125 28.140625 32.472656 26.730469 32.476562 L 10.769531 32.476562 C 9.371094 32.453125 8.25 31.316406 8.25 29.917969 L 8.25 9.496094 C 8.25 8.085938 9.390625 6.945312 10.800781 6.945312 L 26.730469 6.945312 M 26.730469 5.664062 L 10.769531 5.664062 C 8.65625 5.667969 6.945312 7.382812 6.945312 9.496094 L 6.945312 29.917969 C 6.945312 32.03125 8.65625 33.746094 10.769531 33.75 L 26.730469 33.75 C 28.84375 33.746094 30.554688 32.03125 30.554688 29.917969 L 30.554688 9.496094 C 30.554688 7.382812 28.84375 5.667969 26.730469 5.664062 Z M 26.730469 5.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.09375 10.132812 L 26.09375 29.25 L 11.40625 29.25 L 11.40625 10.132812 L 26.09375 10.132812 M 26.09375 8.859375 L 11.40625 8.859375 C 10.703125 8.859375 10.132812 9.429688 10.132812 10.132812 L 10.132812 29.25 C 10.132812 29.953125 10.703125 30.523438 11.40625 30.523438 L 26.09375 30.523438 C 26.796875 30.523438 27.367188 29.953125 27.367188 29.25 L 27.367188 10.132812 C 27.367188 9.429688 26.796875 8.859375 26.09375 8.859375 Z M 26.09375 8.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,38.039216%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 21.726562 13.957031 L 20.03125 13.957031 L 20.03125 12.261719 L 17.46875 12.261719 L 17.46875 13.957031 L 15.773438 13.957031 L 15.773438 16.523438 L 17.46875 16.523438 L 17.46875 18.21875 L 20.03125 18.21875 L 20.03125 16.523438 L 21.726562 16.523438 Z M 21.726562 13.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.03125 12.261719 L 20.03125 13.957031 L 21.75 13.957031 L 21.75 16.5 L 20.03125 16.5 L 20.03125 18.195312 L 17.46875 18.195312 L 17.46875 16.5 L 15.75 16.5 L 15.75 13.957031 L 17.445312 13.957031 L 17.445312 12.261719 L 20.011719 12.261719 M 20.011719 11.625 L 17.46875 11.625 C 17.117188 11.625 16.828125 11.910156 16.828125 12.261719 L 16.828125 13.320312 L 15.75 13.320312 C 15.398438 13.320312 15.113281 13.605469 15.113281 13.957031 L 15.113281 16.5 C 15.113281 16.851562 15.398438 17.136719 15.75 17.136719 L 16.808594 17.136719 L 16.808594 18.195312 C 16.808594 18.546875 17.09375 18.832031 17.445312 18.832031 L 20.011719 18.832031 C 20.363281 18.832031 20.648438 18.546875 20.648438 18.195312 L 20.648438 17.160156 L 21.75 17.160156 C 22.101562 17.160156 22.386719 16.875 22.386719 16.523438 L 22.386719 13.957031 C 22.386719 13.605469 22.101562 13.320312 21.75 13.320312 L 20.671875 13.320312 L 20.671875 12.261719 C 20.671875 11.910156 20.382812 11.625 20.03125 11.625 Z M 20.011719 11.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 15.773438 15.335938 L 15.773438 16.523438 L 17.46875 16.523438 L 17.46875 18.21875 L 20.03125 18.21875 L 20.03125 16.523438 L 21.726562 16.523438 L 21.726562 15.335938 Z M 15.773438 15.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.470588%,56.470588%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 20.542969 6.945312 C 20.621094 6.738281 20.660156 6.519531 20.664062 6.300781 C 20.664062 5.242188 19.804688 4.386719 18.75 4.386719 C 17.695312 4.386719 16.835938 5.242188 16.835938 6.300781 C 16.839844 6.519531 16.878906 6.738281 16.957031 6.945312 L 14.601562 6.945312 L 14.601562 9.496094 L 22.898438 9.496094 L 22.898438 6.945312 Z M 20.542969 6.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,46.666667%,46.666667%)",
      fillOpacity: 1
    },
    d: "M 14.601562 8.21875 L 22.898438 8.21875 L 22.898438 9.492188 L 14.601562 9.492188 Z M 14.601562 8.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.75 4.386719 C 19.257812 4.386719 19.742188 4.589844 20.101562 4.949219 C 20.460938 5.304688 20.664062 5.792969 20.664062 6.300781 C 20.660156 6.519531 20.621094 6.738281 20.542969 6.945312 L 22.898438 6.945312 L 22.898438 9.496094 L 14.601562 9.496094 L 14.601562 6.945312 L 16.957031 6.945312 C 16.878906 6.738281 16.839844 6.519531 16.835938 6.300781 C 16.835938 5.242188 17.695312 4.386719 18.75 4.386719 M 18.75 3.75 C 17.339844 3.75 16.199219 4.890625 16.199219 6.300781 L 14.601562 6.300781 C 14.25 6.304688 13.964844 6.589844 13.964844 6.945312 L 13.964844 9.496094 C 13.964844 9.847656 14.25 10.132812 14.601562 10.132812 L 22.898438 10.132812 C 23.25 10.132812 23.535156 9.847656 23.535156 9.496094 L 23.535156 6.945312 C 23.535156 6.589844 23.25 6.304688 22.898438 6.300781 L 21.300781 6.300781 C 21.300781 4.890625 20.160156 3.75 18.75 3.75 Z M 18.75 3.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.386719 6.300781 C 19.386719 7.148438 18.113281 7.148438 18.113281 6.300781 C 18.113281 5.449219 19.386719 5.449219 19.386719 6.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.199219 23.160156 C 14.027344 23.160156 13.867188 23.09375 13.746094 22.972656 L 12.996094 22.222656 C 12.746094 21.972656 12.746094 21.570312 12.992188 21.320312 C 13.242188 21.066406 13.648438 21.066406 13.898438 21.316406 L 14.183594 21.601562 L 15.308594 20.476562 C 15.554688 20.226562 15.957031 20.226562 16.207031 20.476562 C 16.457031 20.726562 16.457031 21.132812 16.207031 21.382812 L 14.632812 22.957031 C 14.519531 23.078125 14.363281 23.152344 14.199219 23.160156 Z M 14.199219 23.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.671875 21.414062 L 18.113281 21.414062 C 18.019531 21.425781 17.925781 21.398438 17.851562 21.339844 C 17.78125 21.277344 17.742188 21.1875 17.742188 21.09375 C 17.742188 21 17.78125 20.910156 17.851562 20.847656 C 17.925781 20.789062 18.019531 20.761719 18.113281 20.773438 L 23.671875 20.773438 C 23.828125 20.800781 23.945312 20.933594 23.945312 21.09375 C 23.945312 21.253906 23.828125 21.386719 23.671875 21.414062 Z M 23.671875 21.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.113281 22.6875 L 18.113281 22.6875 C 18.019531 22.703125 17.925781 22.675781 17.851562 22.613281 C 17.78125 22.550781 17.742188 22.460938 17.742188 22.367188 C 17.742188 22.273438 17.78125 22.183594 17.851562 22.125 C 17.925781 22.0625 18.019531 22.035156 18.113281 22.050781 L 21.113281 22.050781 C 21.207031 22.035156 21.300781 22.0625 21.371094 22.125 C 21.441406 22.183594 21.484375 22.273438 21.484375 22.367188 C 21.484375 22.460938 21.441406 22.550781 21.371094 22.613281 C 21.300781 22.675781 21.207031 22.703125 21.113281 22.6875 Z M 21.113281 22.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.199219 27 C 14.027344 27 13.867188 26.933594 13.746094 26.8125 L 12.996094 26.0625 C 12.875 25.945312 12.804688 25.78125 12.804688 25.613281 C 12.804688 25.441406 12.875 25.28125 12.996094 25.164062 C 13.246094 24.914062 13.648438 24.914062 13.898438 25.164062 L 14.183594 25.449219 L 15.308594 24.324219 C 15.425781 24.191406 15.589844 24.113281 15.765625 24.109375 C 15.941406 24.105469 16.109375 24.171875 16.234375 24.296875 C 16.359375 24.417969 16.425781 24.589844 16.421875 24.765625 C 16.417969 24.941406 16.339844 25.105469 16.207031 25.222656 L 14.632812 26.796875 C 14.519531 26.917969 14.363281 26.992188 14.199219 27 Z M 14.199219 27 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.671875 25.246094 L 18.113281 25.246094 C 17.933594 25.246094 17.789062 25.101562 17.789062 24.921875 C 17.789062 24.835938 17.824219 24.753906 17.882812 24.695312 C 17.945312 24.632812 18.027344 24.601562 18.113281 24.601562 L 23.671875 24.601562 C 23.753906 24.601562 23.835938 24.632812 23.894531 24.695312 C 23.953125 24.753906 23.988281 24.835938 23.984375 24.921875 C 23.984375 25.097656 23.84375 25.242188 23.671875 25.246094 Z M 23.671875 25.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.113281 26.519531 L 18.113281 26.519531 C 18.019531 26.535156 17.925781 26.507812 17.851562 26.445312 C 17.78125 26.382812 17.742188 26.296875 17.742188 26.203125 C 17.742188 26.105469 17.78125 26.019531 17.851562 25.957031 C 17.925781 25.894531 18.019531 25.867188 18.113281 25.882812 L 21.113281 25.882812 C 21.207031 25.867188 21.300781 25.894531 21.371094 25.957031 C 21.441406 26.019531 21.484375 26.105469 21.484375 26.203125 C 21.484375 26.296875 21.441406 26.382812 21.371094 26.445312 C 21.300781 26.507812 21.207031 26.535156 21.113281 26.519531 Z M 21.113281 26.519531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmSelfcareActive);
export default __webpack_public_path__ + "static/media/ic_sm_selfcare_active.acfb6d79d8bb877d50be28c7d0e9434d.svg";
export { ForwardRef as ReactComponent };